module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.contactLoading),
      expression: "contactLoading"
    }],
    staticClass: "main contact"
  }, [_c('div', {
    staticClass: "contact-part1"
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v(_vm._s(_vm.$t('c-title1')))]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v(_vm._s(_vm.$t('c-title2')))]), _vm._v(" "), _c('div', {
    staticClass: "contact-detail"
  }, [_c('div', {
    staticClass: "contact-detail-dialog"
  }, [_c('div', {
    staticClass: "contact-detail-part1 detail-part"
  }, [_c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('firstname')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_name),
      expression: "first_name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('lastname')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last_name),
      expression: "last_name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-detail-part2 detail-part"
  }, [_c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('workemail')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.work_email),
      expression: "work_email"
    }],
    attrs: {
      "type": "text",
      "id": "work_email"
    },
    domProps: {
      "value": (_vm.work_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.work_email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('phone')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_num),
      expression: "phone_num"
    }],
    attrs: {
      "type": "text",
      "id": "phone_num"
    },
    domProps: {
      "value": (_vm.phone_num)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_num = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-detail-part3 detail-part"
  }, [_c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('company')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company_name),
      expression: "company_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('size')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company_size),
      expression: "company_size"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company_size = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-detail-part4 detail-part"
  }, [_c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('location')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.location = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('industry')))]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry),
      expression: "industry"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.industry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.industry = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-send",
    on: {
      "click": _vm.send
    }
  }, [_vm._v(_vm._s(_vm.$t('send')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-part2"
  }, [_c('div', {
    staticClass: "info-detail"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('emaillabel')) + " "), _c('a', {
    attrs: {
      "id": "email",
      "href": "mailto:info@craitapp.com"
    }
  }, [_vm._v(_vm._s(_vm.$t('email')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c06a2de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact/Contact.vue
// module id = 296
// module chunks = 1